

(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name complaints.controller:CardCtrl
   *
   * @description
   *
   */
  angular
    .module('cards')
    .controller('CardCtrl', CardCtrl);

  function CardCtrl($q, $scope, HelperService, CardsService, $stateParams, $state, $filter) {
    var vm = this;
    vm.card = null;
    vm.cards = [];
    vm.request = { activateCard: true };

    vm.goToNextItem = function () {

      vm.currentIndex++;
      calculateArrowsVisibility();
      if (vm.currentIndex <= vm.cards.length - 1) {
        vm.card = vm.cards[vm.currentIndex];
      }
    };

    vm.goToPreviousItem = function () {

      vm.currentIndex--;
      calculateArrowsVisibility();
      if (vm.currentIndex >= 0) {

        vm.card = vm.cards[vm.currentIndex];
      }
    };

    vm.loadCard = function (cardId) {
      if (!cardId) {
        vm.card = vm.cards[0];
        vm.currentIndex = 0;

      } else {
        vm.card = vm.cards.find(function (item, index) {
          if (item.cardId == cardId) {
            vm.currentIndex = index;
            return true;
          }

          return false;
        });
      }

      calculateArrowsVisibility();
    }

    vm.activateCard = function () {
      vm.step = 2;
    }

    vm.goToCardSettings = function () {
      $state.go('cardSettings', {
        cardId: vm.card.cardId
      })
    }

    function calculateArrowsVisibility() {
      vm.isPreviousButtonVisible = vm.currentIndex > 0;
      vm.isNextButtonVisible = vm.currentIndex < vm.cards.length - 1;
    }

    function init() {
      CardsService.getPage({
        page: 0,
        pageSize: 100,
        orderBy: 'cardHolder desc,cardNumber'
      }).then(function (data) {
        vm.cards = data.result;
        vm.loadCard($stateParams.cardId);
        vm.step = $stateParams.step;
      });
    }

    init();
  }
}());